module.exports = __webpack_public_path__ + "9cf0b8811d72f4b0ebc13a6be6ddac50.jpg";